<div class="wrapper">
  <img src="assets/images/illustration_state_no_access.svg" alt="access limited"/>
  <h4 class="text-center font-weight-bold">
    {{ 'COMMON.access_limited_title' | translate }}
  </h4>
  <p class="text-center text-muted">
    {{ 'COMMON.access_limited_message' | translate }}
  </p>
</div>
